import React from 'react';
import { Button } from 'react-bootstrap';

const toLabel = (entityType) => {
  const value = `${entityType || ''}`.trim().toLowerCase();
  if (value === 'tour') return 'tour';
  if (value === 'zone') return 'zone';
  return 'item';
};

export default function ScheduleNudgePrompt({
  open = false,
  entityType = '',
  entityName = '',
  onConfirm = () => {},
  onDismiss = () => {},
}) {
  if (!open) return null;

  const entityLabel = toLabel(entityType);
  const displayName = entityName || `new ${entityLabel}`;

  return (
    <aside className="responder-schedule-nudge" role="status" aria-live="polite">
      <div className="responder-schedule-nudge__eyebrow">Next step</div>
      <h6 className="responder-schedule-nudge__title">
        Create a schedule for this {entityLabel}?
      </h6>
      <p className="responder-schedule-nudge__copy">
        <strong>{displayName}</strong> was saved. Start a schedule now with this {entityLabel}{' '}
        pre-selected.
      </p>
      <div className="responder-schedule-nudge__actions">
        <Button size="sm" className="responder-schedule-nudge__confirm" onClick={onConfirm}>
          Yes, create schedule
        </Button>
        <Button
          size="sm"
          variant="outline-light"
          className="responder-schedule-nudge__dismiss"
          onClick={onDismiss}
        >
          Not now
        </Button>
      </div>
    </aside>
  );
}
